const successMsgs = {
  resetPassword: "Password updated successfully",
  deletedSuccessfully: "Successfully deleted",
  addedSuccessfully: "Added successfully",
  productApproved: "The product has been accepted successfully",
  productRejected: "The product has been rejected successfully",
  deleteCategorySuccess: "The category has been successfully deleted",
  subCategoryAddedSuccessfully:
    "The sub category has been added successfully",
  subCategoryEditedSuccessfully:
    "The sub category has been edited successfully",
  addCategorySuccess: "The category has been added successfully",
  editCategorySuccess: "The category has been edited successfully",
  addSubCategorySuccess:
    "The Sub category has been added successfully",
  editSubCategorySuccess:
    "The Sub category has been edited successfully",
  deleteSubCategorySuccess:
    "The sub category has been deleted successfully",
  rejectCategoryRequestSuccessfully:
    "The cateogry request has been rejected successfully",
  acceptCategoryRequestSuccessfully:
    "The cateogry request has been accepted successfully",
  offplatformDocumentsSentSuccessfully:
    "Required documents have been sent successfully",
  offplatformDocumentsApprovedSuccessfully:
    "Documents have been approved successfully",
  offplatformEditDocumentsSentSuccessfully:
    "Required documents updates have been sent successfully",
  verificationRequestAcceptedSuccessfully:
    "Verification request has been accepted successfully",
  verificationRequestRejectedSuccessfully:
    "Verification request has been rejected successfully",
  employeeAddedSuccessfully:
    "The employee has been added successfully",
  editEmployeeSuccess: "The employee has been edited successfully",
  reactivateEmployeeSuccess:
    "The employee has been reactivated successfully",
  deactivateEmployeeSuccess:
    "The employee has been deactivated successfully",
  roleAddedSuccess: "The role has been created successfully",
  roleEditedSuccess: "The role has been edited successfully",
  roleDeletedSuccess: "The role has been deleted successfully",
  blockImporter: "Importer account has been successfully blocked.",
  unblockImporter: "Importer account has been successfully unblocked."
};

export default successMsgs;
